module.exports = "/static/assets/6ef72eb649e5b52e25bb2c1f92aa5334.png";